module.exports = {
    version: "web-3.5.9",
    kioskVersion: "kiosk@2.0.0",    
    authorEmail: "hw@pubq.se",
    authorUrl: "pubq.se",
    authorName: "PubQ AB" 
}
